<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Primary Valve Package</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationDetailRow">
        @if (valveSizeSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Package Size:</label>
            <select class="halfWidthInputField" #primaryValveSizeInput
              [class.invalidConfigurationSelection]="isInvalidSelection(valveSizeSelection.Name)"
              (change)="selectionChanged(valveSizeSelection, primaryValveSizeInput.value)"
              [value]="valveSizeSelection.Value.toString()">
              @for (allowable of valveSizeSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="valveSizeSelection.Value && valveSizeSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (flowControlTypeSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Flow Control Type:</label>
            <select class="halfWidthInputField" #primaryFlowControlInput
              [class.invalidConfigurationSelection]="isInvalidSelection(flowControlTypeSelection.Name)"
              (change)="selectionChanged(flowControlTypeSelection, primaryFlowControlInput.value)"
              [value]="flowControlTypeSelection.Value.toString()">
              @for (allowable of flowControlTypeSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="flowControlTypeSelection.Value && flowControlTypeSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (controlValveSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Control Valve:</label>
            <select class="halfWidthInputField" #primaryControlValveInput
              [class.invalidConfigurationSelection]="isInvalidSelection(controlValveSelection.Name)"
              (change)="selectionChanged(controlValveSelection, primaryControlValveInput.value)"
              [value]="controlValveSelection.Value.toString()">
              @for (allowable of controlValveSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="controlValveSelection.Value && controlValveSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (isolationBallValveSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Isolation Ball Valve:</label>
            <select class="halfWidthInputField" #primaryIsolationBallValveInput
              [class.invalidConfigurationSelection]="isInvalidSelection(isolationBallValveSelection.Name)"
              (change)="selectionChanged(isolationBallValveSelection, primaryIsolationBallValveInput.value)"
              [value]="isolationBallValveSelection.Value.toString()">
              @for (allowable of isolationBallValveSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="isolationBallValveSelection.Value && isolationBallValveSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </div>
    </div>
  }
</div>
